import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Actions} from '../../../common/actions';
import {paths} from '../../../common/dictionaries/urls';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import MailGroupForm from './form/index';
import './styles.scss';

class MailGroupEdit extends Component {
  componentDidMount() {
    const {group} = this.props;

    if (!hasAccessPermission(this.props.permissions, resources.MailGroups, scopes.Edit)) {
      this.props.push(paths.AccessDenied);
    }

    if (group) {
      this.props.fetchInternalUsersByGroup(group);
      this.props.fetchExternalUsersByGroup(group);
      this.props.fetchMailGroupInfoByGroup(group);
    }
  }

  componentWillUnmount() {
    this.props.clearInternalUsersList();
    this.props.clearExternalUsersList();
  }

  onSubmit = async(formValues) => {
    const {
      group,
      push,
      internalUsersList,
      externalUsersList,
      updateExternalUsers,
      updateInternalUsers,
    } = this.props;

    if (!group) {
      await this.props.addNewGroupInfo(formValues);
    } else {
      if (updateInternalUsers) {
        await this.props.updateAllInternalUserByGroup(group, internalUsersList);
      }
      if (updateExternalUsers) {
        await this.props.updateAllExternalUserByGroup(group, externalUsersList);
      }
      await this.props.updateGroupInfo(group, formValues);
    }

    push(paths.MailGroupList);
  };

  render() {
    const {push, goBack, group} = this.props;

    return (
      <MailGroupForm
        goBack={goBack}
        push={push}
        onSubmit={this.onSubmit}
        group={group}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'group': ownProps.params.grupo,
    'permissions': state.session.permissions,
    'goBack': ownProps.history.goBack,
    'push': ownProps.history.push,
    'internalUsersList': state.internalUsers.list,
    'externalUsersList': state.externalUsers.list,
    'updateInternalUsers': state.internalUsers.update,
    'updateExternalUsers': state.externalUsers.update,
  };
};

const {
  updateAllInternalUserByGroup,
  updateAllExternalUserByGroup,
  fetchMailGroupInfoByGroup,
  fetchExternalUsersByGroup,
  fetchInternalUsersByGroup,
  clearInternalUsersList,
  clearExternalUsersList,
  addNewGroupInfo,
  updateGroupInfo,
  withRouter,
} = Actions;

export default withRouter(
  connect(mapStateToProps, {
    updateAllInternalUserByGroup,
    updateAllExternalUserByGroup,
    fetchMailGroupInfoByGroup,
    fetchExternalUsersByGroup,
    fetchInternalUsersByGroup,
    clearInternalUsersList,
    clearExternalUsersList,
    updateGroupInfo,
    addNewGroupInfo,
  })(MailGroupEdit)
);
